import React from 'react';
import { Text } from '../../components/UI-CHAKRA/Text';

interface SearchAlternativesProps {
  onClick(): void;
  alternative: string;
}

export default function SearchAlternatives(props: SearchAlternativesProps) {
  return (
    <Text
      as={'span'}
      fontWeight={600}
      cursor={'pointer'}
      pointerEvents={'all'}
      color={'#3484fa'}
      textDecoration={'underline'}
      onClick={props.onClick}
    >
      {props.alternative}
    </Text>
  );
}
